const getEmailSignatureFormatted = (email, signature, agentName) => {
  if (email.isIncomingEmail) {
    return handleEmailSignatureFormatting(
      signature,
      email.incomingEmailData.from,
      email.incomingEmailData.to,
      new Date(email.incomingEmailData.creationTime).toLocaleString(),
      email.incomingEmailData.subject,
      email.incomingEmailData.body,
      agentName
    );
  } else {
    return handleEmailSignatureFormatting(
      signature,
      agentName,
      email.outgoingEmailData.to,
      new Date().toLocaleString(),
      email.outgoingEmailData.subject,
      email.outgoingEmailData.body,
      agentName
    );
  }
};

const handleEmailSignatureFormatting = (signature, ...params) => {
  return replaceValues(signature, ...params);
};

const replaceValues = (formatString, ...params) => {
  params.forEach((param, index) => {
    formatString = formatString.replaceAll(`{${index}}`, param);
  });
  return formatString;
};

export default {
  replaceValues,
  handleEmailSignatureFormatting,
  getEmailSignatureFormatted
};
